export default function Breadcrumb() {
  const { breadcrumbs } = useCtx('userId')
  return (
    <div className='container pt-4'>
      <C.Breadcrumb list={ breadcrumbs } />
    </div>
  )
}
